<div class="d-flex container">
  <div>
    <div class="section-title pb-30" style="margin-top: 20px">
      <h2 class="title" style="color: #3e166c !important; font-weight: 700">
        Privacy Policy
      </h2>
    </div>

    <div class="tito" style="font-weight: 700;" >PRIVACY NOTICE</div>

    <div class="level-1">Last updated May 8th of 2025</div>

    <div class="level-1">
      This privacy notice for Klickit and Klickit Technologies Ltd (collectively referred to throughout as “Klickit”  "Company," "we," "us," or "our"), 
      describes how and why we might collect, store, use, and/or share ("process") your personal data when you use our services ("Services"), such as when you:
    </div>

    <ul class="level-1 bulletlist "  >
      <li>visit our website at https://klickit.co/ , or any website of ours that links to this privacy notice; 
        we may collect your personal data through cookies collected or our online forms</li>
      <li>engage with us in other related ways ― including any sales, marketing, or events</li>
      <li>become a customer of Klickit</li>
      <li>are a representative of a third party e.g. a partner, vendor or professional services company </li>
      <li>are an enquirer or complainant</li>
    </ul>
    <div class="level-1">
      If you are a student or parent of an educational facility, you may contact them to request 
      a copy of their Privacy Notice since they are the controller of your personal data. 
    </div>

    <div class="level-1">
      Klickit Technologies Ltd is committed to protecting your privacy and processing your personal data 
      (also referred to throughout as “information”) fairly and lawfully in compliance with the DIFC Data Protection Law No.5 of 2020.
    </div>

    <div class="level-1">
      Questions or concerns? Reading this privacy notice will help you understand your privacy rights and choices. If you have any questions or concerns, please
      contact us at <a target="_blank" href="mailto: privacy@klickit.co" style="cursor: pointer;">privacy@klickit.co</a>.
    </div>

    <div class="tito">SUMMARY OF KEY POINTS</div>

    <div class="level-1 bold italic">
      This summary provides key points from our privacy notice, but you can find out more details about any of these
      topics below.
    </div>

    <div class="level-1">
      <span class="bold">What personal information do we process?</span>&nbsp;
      When you visit, use, or navigate our Services, we may process your personal information.
       We have detailed the types of information you can expect us to process below. 
    </div>

    <div class="level-1">
      <span class="bold">
        Do we process any sensitive personal information?</span>&nbsp;
        We do not generally process sensitive information. However, if we do process sensitive data we will update this notice 
        detailing the purpose and  appropriate legal basis. In limited circumstances, we will provide you with a separate notice..

    </div>

    <!-- <div class="level-1">
      <span class="bold">Do you receive any information from third parties?</span>&nbsp; We may receive information from
      public databases, marketing
      partners, social media platforms, and other outside sources.
    </div> -->

    <!-- <div class="level-1">
      <span class="bold"> How do you process my information?</span>&nbsp; We
      process your information to provide, improve, and administer our Services,
      communicate with you, for security and fraud prevention, and to comply
      with the law. We may also process your information for other purposes with
      your consent. We process your information only when we have a valid legal
      reason to do so.
    </div> -->

    <!-- <div class="level-1">
      <span class="bold">
        In what situations and with which parties do we share personal
        information?</span>&nbsp;
    </div> -->

    <!-- <div class="level-1">
      We may share information in specific situations and with specific third
      parties.
    </div> -->

    <div class="level-1">
      <span class="bold"> How do we keep your information safe?</span>&nbsp;We prioritize the security of your personal data. We have put in place
       appropriate technical and organisational measures to protect against the accidental or unlawful destruction, loss, alteration, unauthorised
        disclosure of or access to personal data processed. 

    </div>

    <div class="level-1">
      <span class="bold"> What are your rights?</span>&nbsp; Depending on where you are located geographically, the
      applicable privacy law may mean you have certain rights regarding your personal information.
    </div>

    <div class="level-1">
      <span class="bold"> How do I exercise my rights?</span>&nbsp; The easiest way to exercise your rights is by contacting us via the details shown in 
      section 11 below. We will consider and act upon any request in accordance with applicable data protection laws.
    </div>

    <div class="level-1">
      Want to learn more about what Klickit does with any information we
      collect?
    </div>

    <div class="tito">
      1. WHAT INFORMATION DO WE COLLECT? 
    </div>

    <div class="level-1">
      We collect personal information that you voluntarily provide to us when you register to our Services, express an interest in obtaining information about us 
      or our products and Services, when you participate in activities relating to the Services, or otherwise when you contact us.
    </div>

    <!-- <div class="level-1">
      <span class="bold">Personal Information Provided by You.</span>&nbsp; The
      personal information that we collect depends on the context of your
      interactions with us and the Services, the choices you make, and the
      products and features you use. The personal information we collect may
      include the following:
    </div> -->

    <!-- <div class="level-2">
      <ul>
        <li>- Names</li>
        <li>- Phone numbers</li>
        <li>- Email addresses</li>
        <li>- Mailing addresses</li>
        <li>- Job titles</li>
        <li>- Usernames</li>
        <li>- Passwords</li>
        <li>- Contact or authentication data billing addresses</li>
        <li>- Debit/credit card numbers</li>
      </ul>
    </div> -->

    <div class="level-2">
      <span class="bold">Personal Data:</span>
      <span>The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, 
        and the products and features you use. For example, the personal data we collect may include without limitation:</span>
    </div>

    <ul class="level-2 bulletlist "  >
      <li>Website users:  </li>
      <div>Full name, email address, contact number, company name. We also collect personal data via cookies on the website, 
        see section [X] for more information]</div>
      <li>Parties engage with us in relation to sales, marketing, or events: </li>
      <div> Full name, email address, contact number, company name, job title.</div>
      <li>Klickit customers: </li>
      <div>we may process the data of the representatives of your company, including their full name, email address, contact number, 
        company name, job title, and identification documents such as passport or national ID.</div>
      <li>Representative of third-parties: </li>
      <div> Full name, email address, contact number, company name, job title.</div>
      <li>Enquirers or complainants:</li>
      <div>Full name, email address, contact number, company name, job title.</div>

    </ul>

    <div class="level-2">
      <span class="bold">Sensitive Data:</span>
      <span>We do not generally process sensitive data, however, if we choose to collect this in future we will ensure that you are informed of this, 
        including the purpose and legal basis amongst other things.  </span>
    </div>
    <div class="level-2">
      <span class="bold">Payment Data: </span>
      <span>We process payment data on behalf of educational facilities, using  Klickit’s affiliate business partners. You may contact the educational
         facility details of their Privacy Notice, as the controller of your data. </span>
    </div>

    <!-- <div class="level-1 veryBold">Information collected from other sources</div>

    <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We may collect limited
      data from public databases, marketing partners, and other outside sources.
    </div>

    <div class="level-1">
      In order to enhance our ability to provide relevant marketing, offers, and
      services to you and update our records, we may obtain information about
      you from other sources, such as public databases, joint marketing
      partners, affiliate programs, data providers, and from other third
      parties. This information includes mailing addresses, job titles, email
      addresses, phone numbers, intent data (or user behavior data), Internet
      Protocol (IP) addresses, social media profiles, social media URLs, and
      custom profiles, for purposes of targeted advertising and event promotion.
    </div> -->

    <div class="tito">2. WHAT IS THE PURPOSE OF THE DATA PROCESSING?    </div>

    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We process your
      information to provide, improve, and administer our Services, communicate
      with you, for security and fraud prevention, and to comply with law. We
      may also process your information for other purposes with your consent.
    </div> -->


    <div class="level-1">
      <span class="bold">
        We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</span>
    </div>

   
      <ul class="level-2 bulletlist">
        <li>To ensure efficient operations, including facilitating account creation, authentication and management of accounts.</li>
        <li>To deliver and facilitate delivery of services.</li>
        <li>To respond to inquiries/offer support.</li>
        <li>To enable efficient communications.</li>
        <li>To evaluate and improve our Services, products, marketing, and your experience.</li>
        <li>To comply with our legal obligations.</li>
        <li>To enter into or perform a contract with you or your company.</li>
      </ul>
   

    <!-- <div class="level-1">
      <span class="bold">
        To facilitate account creation and authentication and otherwise manage
        user accounts.</span>&nbsp; We may process your information so you can create and log in to
      your account, as well as keep your account in working order.
    </div>

    <div class="level-1">
      <span class="bold">
        To deliver and facilitate the delivery of services to the user..</span>&nbsp; We may process your information to
      provide you with the requested
      service.
    </div>
    <div class="level-1">
      <span class="bold">
        To respond to user inquiries/offer support to users.</span>&nbsp; We may process your information to respond to
      your inquiries and
      solve any potential issues you might have with the requested service.
    </div> -->

    <!-- <div class="level-1">
      <span class="bold"> To enable user-to-user communications.</span>&nbsp; We
      may process your information if you choose to use any of our offerings
      that allow for communication with another user.
    </div> -->
    <!-- <div class="level-1">
      <span class="bold">
        To evaluate and improve our Services, products, marketing, and your
        experience.</span>&nbsp; We may process your information when we believe it is necessary to
      identify usage trends, determine the effectiveness of our promotional
      campaigns, and to evaluate and improve our Services, products, marketing,
      and your experience.
    </div>
    <div class="level-1">
      <span class="bold"> To comply with our legal obligations.</span>&nbsp; We
      may process your information to comply with our legal obligations, respond
      to legal requests, and exercise, establish, or defend our legal rights.
    </div> -->

    <div class="tito">
      3. WHAT IS THE LAWFUL BASIS FOR PROCESSING?
    </div>
    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We may share information
      in specific situations described in this section and/or with the following
      third parties.
    </div> -->
    <div class="level-1">
      Klickit relies on the following lawful basis for the processing of Personal Data, please note that more than one may apply in a particular scenario:
    </div>
    <ul class="level-2 bulletlist">
      <li>For the performance of a contract or in order to take steps at your request prior to entering into such contract</li>
      <li>For compliance with a legal obligation to which Klickit is subject</li>
      <li>Based on your consent (in limited circumstances, e.g. when you sign up for marketing material, this consent can be withdrawn at any time)      </li>
      <li>Processing of information made public by a Data Subject </li>
      <li>In relation to legal claims, in limited circumstances</li>
      <li>For the purposes of our legitimate interests or the legitimate interests of a third party to whom your personal data is provided; we will not 
        process your personal data for these purposes if our or the third party’s legitimate interests should be overridden by your own interests or fundamental 
        rights and freedoms. The legitimate interests pursued by us in this regard may include: 
        <ul class="level-2 bulletlist" style="list-style-type: circle;">
          <li>Conducting our business in a responsible and commercially prudent manner and dealing with any disputes that may arise;</li>
          <li>Preventing, investigating or detecting theft, fraud or other criminal activity;</li>
          <li>Pursuing our legitimate corporate and ethical, social, and governance
            responsibility objectives.</li>
        </ul> 
      </li>
      
    </ul>
    
    <!-- <div class="level-1">
      For other purposes: We may use your information for other purposes, such
      as data analysis, identifying usage trends, determining the effectiveness
      of our promotional campaigns and to evaluate and improve our Service,
      products, services, marketing and your experience
    </div> -->

    <div class="tito">
      4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
    </div>

    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We may use cookies and
      other tracking technologies to collect and store your information.
    </div> -->
    <div class="level-1">
      We may need to share your personal information in the following situations:
      
    </div>
    <div class="level-1">
      <div>
      <span style="font-weight: 700;" > Business Transfers:</span> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets,
       financing, or acquisition of all or a portion of our business to another company. We may also transfer to our group entities, for example in Egypt
        or Dubai for the purpose of utilising group services.
      </div>
      <div>
        <span style="font-weight: 700;" > Third Parties:</span> We may share your information with service providers who assist us in providing our services to you. In limited circumstances, 
        we may share information with our business partners to offer you certain products, services, or promotions, generally, this would be based on consent, 
        which you may withdraw at any time.
      </div>
    </div>
    <div class="level-1" >
      Where we transfer to jurisdictions that may be considered non-adequate we will ensure that relevant contracts are in place to safeguard the data or to rely on appropriate derogations.
    </div>
    

    <div class="tito">5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</div>

    <!-- <div class="level-1">
      In Short: We keep your information for as long as necessary to fulfill the
      purposes outlined in this privacy notice unless otherwise required by law.
    </div> -->
    <div class="level-1">
      We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information.
    </div>
    <div class="level-1">
      Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our Services.
    </div>

    <div class="tito">6. HOW LONG DO WE KEEP YOUR INFORMATION?</div>

    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We aim to protect your
      personal information through a system of organizational and technical
      security measures.
    </div> -->
    <div class="level-1">
      We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, 
      unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements). 
    </div>
    <div class="level-1">
      When we have no ongoing legitimate business or legal need to process your personal information, we will either delete or anonymize such information,
       or, if this is not possible then we will securely store your personal information and isolate it from any further processing until deletion is possible.
    </div>

    <div class="tito">7. HOW DO WE KEEP YOUR INFORMATION SAFE?</div>
    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: We do not knowingly
      collect data from or market to children under 18 years of age. Except
      Students Name & Payment Data to be able to identify payment cycles and
      deadlines.
    </div> -->
    <div class="level-1">
      We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information 
      we process . Measures include but are not limited to role-based access controls, strict password protocols, training, encryption, data protection and 
      information security policies and procedures. 
    </div>

    <div class="tito">8. DO WE PROCESS INFORMATION OF MINORS?</div>

    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp;: You may review, change,
      or terminate your account at any time.
    </div> -->

    <div class="level-1">
      We are not a data controller of any personal data relating to minors (under 18 years of age). However, our customers (i.e. educational facilities) 
      may use our platform to process the data of parents, and students for the effective management of educational fees. Please refer to the Privacy Notice
       provided by your particular educational facility for further details of how they process your personal data.
    </div>
    

    <div class="tito">9. WHAT ARE YOUR PRIVACY RIGHTS?</div>

    <div class="level-1">
      <div>As a data subject of Klickit, depending on the jurisdiction, you may have the following rights concerning your personal data:</div>
      <ul class="level-2 bulletlist">
        <li>The right to access </li>
        <li>The right to erase </li>
        <li>The right to restrict processing</li>
        <li>The right to rectify any inaccuracies</li>
        <li>The right to withdraw consent, please note that this will not affect the lawfulness of the processing before its withdrawal</li>
        <li>The right to object to processing</li>
        <li>The right to data portability</li>
        <li>The right to non-discrimination for exercising your rights</li>
        <li>The right to not be subject to automates processing, including profiling: we can confirm that this right would not apply since Klickit does
           not perform this type of processing</li>
        <li>The right to be notified, of any rectification, erasure or processing restriction</li>
      </ul>
  
    </div>
    <div class="level-1">
      <div>Account Information</div>
       <div>  If you would at any time like to review or change the information in your account or terminate your account, you can: </div>
       <div>Log in to your account settings and update your user account.</div>
       <div>Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. 
        However, in limited circumstances we may be required to retain data for longer if necessary in connection with legal claims or to comply
         with applicable laws. To exercise any of the rights above, you may contact us at any time using the details below. </div>
    </div>

    <div class="tito">10. DO WE MAKE UPDATES TO THIS NOTICE?</div>
    <!-- <div class="level-1">
      <span class="bold italic">In Short:</span>&nbsp; Yes, we will update this
      notice as necessary to stay compliant with relevant laws.
    </div> -->
    <div class="level-1">
      We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date at the top of the notice, 
      and the updated version will be effective as soon as it is accessible on our website. We encourage you to access our website Privacy Notice frequently
       to be informed of the latest information.
    </div>

    <div class="tito">11. HOW CAN YOU CONTACT US OR MAKE A COMPLAINT?</div>

    <div class="level-1">
      If you have questions or comments about this notice, you may email us at <a target="_blank" href="mailto: privacy@klickit.co" style="cursor: pointer;">privacy@klickit.co</a>  or by post to:
    </div>
    <div class="level-1">
      Klickit (Egypt)<br />
      Office 221, Centro Egypt Mall, 5th Settlement, New Cairo, Cairo, Egypt
      Cairo 11835<br />
      Egypt <br />
    </div>
    <div class="level-1">
      Klickit Technologies Ltd (UAE)<br />
      Office 201, Level 1, Gate Avenue - South Zone, DIFC, Dubai,<br />
      UAE <br />
    </div>
    <div class="level-1">
      If you a data subject of our UAE entity and you are not satisfied with our response or believe we are not processing your personal data in accordance
       with the law, you can escalate your complaint to the supervisory authority via the following details: DIFC Data Protection Commissioner, DIFC Authority,
        Level 14, The Gate Building, DIFC, Dubai, UAE / +971 4 362 2222 / <a target="_blank" href="mailto: commissioner@dp.difc.ae " style="cursor: pointer;">commissioner@dp.difc.ae </a> 
    </div>

    <div class="tito">
      12. ACCURACY OF DATA
    </div>
    <div class="level-1">
      All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
      If you refuse to provide the requested information, we may be unable to provide our services to you.

    </div>
    <br /><br /><br /><br /><br />
  </div>
</div>